import React from "react"
import { Link } from "gatsby"
import { Nav } from "react-bootstrap"
import "./menu.css"

import Logo from "../../images/logo.png"

export default ({ toggle }) => (
  <div className="navigation">
    <Link to="/">
      <img className="w-100  sidebar-logo" src={Logo} alt="Epiphron Logo" />
    </Link>

    <Nav className="flex-column text-center">
      <Nav.Item className="hvr-shutter-out-horizontal">
        <Link onClick={toggle} to="/">
          Home
        </Link>
      </Nav.Item>
      <Nav.Item className="hvr-shutter-out-horizontal">
        <Link onClick={toggle} to="#about">
          About Us
        </Link>
      </Nav.Item>
      <Nav.Item className="hvr-shutter-out-horizontal">
        <Link onClick={toggle} to="#services">
          What We Offer
        </Link>
      </Nav.Item>
      {/* <Nav.Item className="hvr-shutter-out-horizontal">
        <Link to="/about-us">Client Reviews</Link>
      </Nav.Item> */}
      <Nav.Item className="hvr-shutter-out-horizontal">
        <Link onClick={toggle} to="/">
          Contact Us
        </Link>
      </Nav.Item>
    </Nav>
  </div>
)
